import { Box, FormControl, HStack } from '@chakra-ui/react'
import { MultiSelect, Option } from 'chakra-multiselect'
import { useMemo } from 'react'
import { normalizeProvocationType } from '../../utils/labHelpers'

const PROVOCATION_TYPES = [
  {
    value: 'Deep tissue massage once per hour during collection period',
    label: 'Deep tissue massage once per hour during collection period',
  },
  {
    value: 'DMSA Oral (not recommended)',
    label: 'DMSA Oral (not recommended)',
  },
  {
    value: 'DMPS IV (not recommended)',
    label: 'DMPS IV (not recommended)',
  },
  {
    value: 'DMPS Oral (not recommended)',
    label: 'DMPS Oral (not recommended)',
  },
  {
    value: 'EDTA Calcium IV (not recommended)',
    label: 'EDTA Calcium IV (not recommended)',
  },
  {
    value: 'EDTA Liposomal Oral',
    label: 'EDTA Liposomal Oral',
  },
  {
    value: 'EDTA Sodium IV (not recommended)',
    label: 'EDTA Sodium IV (not recommended)',
  },
  {
    value: 'Emerimide (OSR) Oral',
    label: 'Emerimide (OSR) Oral',
  },
  {
    value: 'Vibration machine once per hour during collection period',
    label: 'Vibration machine once per hour during collection period',
  },
]

interface ProvocationTypeSelectorProps {
  value: string | string[] | undefined
  onChange: (value: string[]) => void
  isDisabled?: boolean
  isInvalid?: boolean
}

export default ({
  value,
  onChange,
  isDisabled = false,
  isInvalid = false,
}: ProvocationTypeSelectorProps) => {
  // Normalize value to array format
  const normalizedValue = useMemo(() => {
    const normalized = normalizeProvocationType(value)
    if (!normalized) return []
    return PROVOCATION_TYPES.filter((opt) => normalized.includes(opt.value))
  }, [value])

  const handleChange = (selectedOptions: Option | Option[]) => {
    const optionsArray = Array.isArray(selectedOptions)
      ? selectedOptions
      : [selectedOptions]
    const values = optionsArray.map((opt) => String(opt.value))
    onChange(values)
  }

  return (
    <Box mt='3' mb='3'>
      <FormControl maxW='md' isInvalid={isInvalid}>
        <HStack spacing={2} alignItems='center'>
          <Box fontWeight='semibold' fontSize='sm'>
            Type of provocation (can select more than one):
          </Box>
          <MultiSelect
            options={PROVOCATION_TYPES}
            value={normalizedValue}
            onChange={handleChange}
            placeholder='Select one or more...'
            disabled={isDisabled}
            size='sm'
          />
        </HStack>
      </FormControl>
    </Box>
  )
}
